import React from 'react';
import Filter from "./Filter";

const Sort = ({ onSortParts, onChangeSortDir, onSetFilters, filters, showFilters }) => {

	return (
		<div className='gray pa2 pb1 pv1-ns f6 flex justify-between items-center w-50-ns'>
			<label><span className='mr1 nowrap'>Sort By:</span>
				<select onChange={onSortParts} className='bn bg-transparent outline-0 w-auto di f7 brand-magenta hover-brand-magenta'>
					<option value='name'>Name</option>
					<option value='rarity'>Rarity</option>
					<optgroup label='Stats'>
						<option value='stats-armor' selected>Armor</option>
						<option value='stats-atk_melee'>Melee ATK</option>
						<option value='stats-atk_shot'>Shot ATK</option>
						<option value='stats-def_melee'>Melee DEF</option>
						<option value='stats-def_shot'>Shot DEF</option>
						<option value='stats-res_beam'>Beam RES</option>
						<option value='stats-res_phys'>Phys RES</option>
					</optgroup>
					<optgroup label='Skill Stats'>
						<option value='skill_pierce'>Pierce</option>
						<option value='skill_power'>Power</option>
						<option value='skill_recovery'>Recovery</option>
					</optgroup>
				</select>
			</label>
			<label className='sort-dir fr pointer brand-magenta hover-brand-magenta hightolow' onClick={onChangeSortDir} />
			<Filter onSetFilters={onSetFilters} filters={filters} onShowFilters={showFilters} />
		</div>
		)
};

export default Sort;